import styled from 'styled-components';

export const ItemContainer = styled.button`
  outline: none;
  border: none;
  background-color: ${(props) => props.theme.palette.white};
  width: 145px;
  height: 125px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 14px ${(props) => props.theme.palette.darkTransparency};
  cursor: pointer;
  span {
    color: ${(props) => props.theme.palette.gray3};
  }
  &:nth-child(odd) {
    margin-left: 0;
  }
  &:nth-child(even) {
    margin-right: 0;
  }
  @media (max-width: 330px) {
    width: 120px;
    height: 105px;
  }
`;

export const CardTitle = styled.div`
  margin-top: ${(props) => props.theme.spacing.small};
  color: ${(props) => props.theme.palette.gray3};
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;
